import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImageType } from 'src/app/models/image.model';

@Component({
  selector: 'app-image-section',
  templateUrl: './image-section.component.html',
  styleUrls: ['./image-section.component.scss']
})
export class ImageSectionComponent {
  @Input() image: string | undefined = undefined;
  @Input() index: number = -1;
  @Input() imageType: ImageType;
  @Input() editEnabled = false;
  @Input() permission = true;
  @Input() inputId = '';

  @Output() imageClick = new EventEmitter<number>();
  @Output() fileChange = new EventEmitter<{ file: File, type: ImageType, imageId: number }>();

  onImageClick() {
    this.imageClick.emit(this.index);
  }

  onFileSelected(event: any) {
    const file = event.target.files.item(0);
    if (file) {
      this.fileChange.emit({
        file,
        type: this.imageType,
        imageId: this.editEnabled ? this.index : -1
      });
    }
  }
}
